import type { MigrationStrategies } from 'rxdb';
import type { SignAndStampFileDocument } from './signAndStamp.types';

export const signAndStampFileMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: SignAndStampFileDocument) => {
    const newDoc = {
      ...oldDoc,
    };
    delete newDoc.inspectorId;
    return newDoc;
  },
};
